const priceCache = {}

export const addCurrency = (price) => {
  priceCache[price] = priceCache[price] || (MK.activeCurrencySymbol === '$' ? `${MK.activeCurrencySymbol}${price}` : `${price} ${MK.activeCurrencySymbol}`)
  return priceCache[price]
}